import React, { Component } from "react";
import styles from "./userStateDropDownMenu.module.scss";

import DropDownItem from "./items/contols/dropDownItem";
import LogoutIcon from "@mui/icons-material/Logout";
import InfoIcon from "@mui/icons-material/Info";
import { withAppState } from "./containers/containerAppState";
import { withAuth } from "./containers/containerAuth";
import ModalInfoApp from "../components/Contents/ModalComponents/ModalInfoApp";

class UserStateDropDownMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenInfo: false,
    };
  }

  render() {
    const { onLogOut } = this.props;
    const { isOpenInfo } = this.state;

    return (
      <div>
        <DropDownItem>
          <div
            className={styles.dropDownItemContent}
            onClick={(e) => {
              this.setState({ isOpenInfo: !isOpenInfo });
            }}
          >
            <InfoIcon />
            <button>О программе</button>
          </div>
        </DropDownItem>
        <DropDownItem>
          <div className={styles.dropDownItemContent} onClick={onLogOut}>
            <LogoutIcon />
            <button>Выйти</button>
          </div>
        </DropDownItem>

        <ModalInfoApp
          isOpen={isOpenInfo}
          onCloseHandler={() => {
            this.setState({ isOpenInfo: false });
          }}
        />
      </div>
    );
  }
}

export default withAppState(withAuth(React.memo(UserStateDropDownMenu)));
